<template>
  <ts-menu>
    <div>
      <div v-if="showProjectMenu">
        <ts-menu>
          <div class="content project-menu">
            <!-- <ts-menu-item :to="{ name: 'project-brief' }"> Brief</ts-menu-item> -->
            <!-- <ts-menu-item :to="{ name: 'project-assets' }"> Assets</ts-menu-item>-->
            <!-- <ts-menu-item :to="{ name: 'project-production' }"> Production</ts-menu-item>-->
           <ts-menu-item :to="{ name: 'project-delivery' }"> Delivery</ts-menu-item>
            <!--<ts-menu-item :to="{ name: 'project-documents' }"> Documents</ts-menu-item>-->
           <visible :when="hasPermission">
             <ts-menu-item :to="{ name: 'project-details' }"> Project details</ts-menu-item>
           </visible>
           <div v-if="showProjectDetailsSubMenu">
             <ts-menu-sub-item :to="{ name: 'project-details-general-info' }">
               <template #icon>
                 <MenuCheck :checked="isCurrentProjectDetailStepDone('generalInfo')"/>
               </template>
               <span>General info</span>
             </ts-menu-sub-item>
             <!-- <ts-menu-sub-item :to="{ name: 'project-details-review' }">
                <template #icon>
                  <MenuCheck :checked="isCurrentProjectDetailStepDone('projectReview')"/>
                </template>
                <span>Feedback</span>
              </ts-menu-sub-item>-->
             <!--<div class="ts-menu-item ql">
              <MenuCheck :checked="true"/>
              <a
                  @click="
                openLinkInNewTab(
                  'https://docs.google.com/spreadsheets/d/1hS-YJDOyn-NbCEEjit9-mO0BsaVt6xqYnakJiKC87Pg/edit#gid=774228297'
                )
              "
                  class="router-link-exact-active router-link-active lenient"
              >
                <span>Quotelist</span>
                </a>
              </div>-->
              <!-- <ts-menu-sub-item :to="{ name: 'project-details-origin' }">
                <template #icon> <MenuCheck :checked="isCurrentProjectDetailStepDone('projectOrigin')" /> </template>
                <span>Project origin</span>
              </ts-menu-sub-item>-->
            </div>
          </div>
        </ts-menu>
      </div>
      <div v-else>
        <div class="content">
          <ts-menu-group>Production</ts-menu-group>
          <ts-menu-item :to="{ name: 'my-projects' }">
            <template #icon>
              <ts-icon icon="time" size="x-small" color="#6d7587"/>
            </template>
            My projects
          </ts-menu-item>
          <!--<ts-menu-item :to="{ name: 'feedbacks' }" v-if="isAdmin">
            <template #icon>
              <ts-icon icon="plus" size="x-small" color="#6d7587"/>
            </template>
            Feedbacks
          </ts-menu-item>-->
        </div>
      </div>
    </div>
  </ts-menu>
</template>

<style lang="scss" scoped>
.content {
  margin: 8px;
}

.project-menu {
  margin-top: 48px;
}

.ql {
  font-family: Roboto;
  font-size: 16px;
  color: #33373d;
  cursor: pointer;
  display: block;
  padding: 2px 0 2px 16px;
  margin: 4px 0;
  text-decoration: none;
  border: 1px solid transparent;
  display: flex;
}
.ql span {
  margin-left: 8px;
}
</style>

<script>
import {mapState} from 'vuex';

import MenuCheck from '@/components/MenuCheck';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    MenuCheck
  },
  props: {
    showProjectMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workflowEnabled: false,
      showProjectDetailsSubMenu: false,
      creativeDriversEnabled: false,
      creativeWallEnabled: false
    };
  },
  computed: {
    ...mapState('workflow', {
      currentProject: state => state.currentProject.value
    }),
    hasPermission() {
      return this.isProjectManager;
    }
  },
  methods: {
    isCurrentProjectDetailStepDone(step) {
      if (!this.currentProject) {
        return false;
      }
      return this.currentProject.statusDetails.details[step] === 'done';
    },
    openLinkInNewTab(url) {
      window.open(url, '_blank');
    }
  },
  mounted() {
    const appSettings = window.config();
    this.workflowEnabled = !!appSettings?.workflow?.enabled;
    this.showProjectDetailsSubMenu = !!this.$router?.currentRoute?.meta?.showProjectDetailsSubMenu;
    this.creativeDriversEnabled = !!appSettings?.creativeDrivers?.enabled;
    this.creativeWallEnabled = !!appSettings?.creativeWall?.enabled;
  }
};
</script>
